import {ResearchWidgetKind} from '../../../data/ResearchTypes';

/**
 * The second pass of building a dashboard (rzx-backend/docs/decisions/0038): the dashboard assistant
 * plans each widget and gives it a purpose, then the widget's own assistant finishes it for that
 * purpose with this instruction. The widget's assistant sees its rows as sample values, which the
 * dashboard assistant never does.
 *
 * NOTE: the refine cases of the grid and chart evals use this wording - keep them in step.
 */
export function refineInstruction(kind: ResearchWidgetKind, purpose: string): string {
    return kind === 'chart'
        ? `Finish this chart for its purpose: "${purpose}". Going by the sample values, choose the chart type that suits the data ` +
              '(columns for yearly or quarterly figures, lines for long daily or monthly series), the series that serve the purpose, ' +
              "clear series names and axis titles, and number formats that suit the values' unit and size: amounts in the tens of billions or more read best in billions. Change only what makes it read better."
        : `Finish this grid for its purpose: "${purpose}". Going by the sample values, choose the columns that serve the purpose and their order, ` +
              "remove columns that have no sample values, give clear headers, and set number formats that suit the values' unit and size: amounts in the tens of billions or more read best in billions. " +
              'Change only what makes it read better.';
}
